import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { USER_URL } from '@insite-store360/shared';
import { catchError, Observable } from 'rxjs';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
    providedIn: 'root',
})
export class FilterDetailsService {
    private readonly FILTER_DETAILS_URL = `${USER_URL}/filter`;

    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService
    ) { }


    public getYears(): Observable<any> {
        return this.http
            .get<any>(
                `${this.FILTER_DETAILS_URL}/getAllYears`, {}
            )
            .pipe(catchError(this.errorHandler.handleError));
    }



    public getMonths(params: { year: number }): Observable<any> {


        let queryParams = new HttpParams()
        if (params.year) {
            queryParams = queryParams.append('year', params.year.toString());
        }
        return this.http
            .get<any>(
                `${this.FILTER_DETAILS_URL}/getAllMonthYears`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }


    public getWeeks(params: { year: number }): Observable<any> {


        let queryParams = new HttpParams()
        if (params.year) {
            queryParams = queryParams.append('year', params.year.toString());
        }
        return this.http
            .get<any>(
                `${this.FILTER_DETAILS_URL}/getAllWeeks`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }


}